import React from "react";
import { translate } from "react-i18next";
import { Button, Modal } from "semantic-ui-react";
import DeleteAxios from "../axiosComponent/delete";

function DeleteModal(props) {
  const { t } = props;
  let DeleteItem = () => {
    if(props.deleteItem){
      props.deleteItem()
    }else{
      DeleteAxios({
        url: `users/${props.productName}`,
        uniqueId: props.id,
        payload: { userName: props.editParams.userName },
      }).then((response) => {
        console.log('RES', response)
        window.location.reload()
      }).catch((err) => alert(err.data.message))

    }
  }
  return (
    <Modal onClose={props.CloseModal} open={props.deleteOpen} size="mini">
      <Modal.Header>{t("notification")}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>{t("message")}</p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="green"
          size="mini"
          type="button"
          onClick={props.CloseModal}
        >
          {t("cancel")}
        </Button>
        <Button type="button" size="mini" color="blue" onClick={DeleteItem}>
          {t("ok")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default translate('user_table')(DeleteModal);
